<span #dom data-component-type="prosemirror-image" [attr.data-resizable]="isEditable || null">
  <figure [class]="htmlClass || null" [style]="figureStyle">
    <ng-container *ngTemplateOutlet="resizerEl" />
    @if (caption) {
      <figcaption>{{ caption }}</figcaption>
    }
  </figure>
</span>

<ng-template #resizerEl>
  <span class="resizer-wrap">
    <ng-container *ngTemplateOutlet="href ? hrefEl : imgEl" />
    <div (mousedown)="initResize($event)" class="resize-handle"></div>
  </span>
</ng-template>

<ng-template #hrefEl let-content="content">
  <a [href]="href" (click)="$event.preventDefault()" [attr.target]="targetBlank ? '_blank' : null">
    <ng-container *ngTemplateOutlet="imgEl" />
  </a>
</ng-template>

<ng-template #imgEl>
  <div class="img-wrap">
    <img [src]="src" [style]="imgStyle" [alt]="alt" />
  </div>
</ng-template>
